exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-settings .invoice-settings__form {\n  margin-top: 5rem;\n  padding: 0 9rem;\n}\n\n.invoice-settings .invoice-settings__form>div {\n  margin-top: 4rem;\n}\n\n.invoice-settings .invoice-settings__form>div:first-child {\n  margin-top: 0;\n}\n\n", ""]);

// exports
